const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is the refund or cancellation policy for day tours?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Full refunds will be issued to guests that provide notice of cancellation via e-mail or telephone at least 24 hours prior to departure time for all day tours. Cancellations made with less notice than the time frames listed above will be subject to a $50 per person cancellation fee.'
      }
    },
    {
      '@type': 'Question',
      name: 'Can we customize a tour or replace an attraction?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Should you wish to customize a tour, we are happy to offer a Private Tour option. Private tours are fully customizable and designed around what you want to see and do. The base price for a private tour includes: personal guide/driver, transportation, parking fees, light snacks and non-alcoholic beverages, and a full driving tour of the area with commentary. Attractions and meals are optional - any activities or meals you would like to do would be at an additional cost. If there is an attraction included in your tour that you are not interested in, please let your guide know. In this instance, you will be given free time to spend at that attraction while the other guests in your group participate.'
      }
    },
    {
      '@type': 'Question',
      name: 'Do you have car seats available?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Trip Shepperd Tours does not provide car seats for children. By law, children less than 8 years of age can sit on an adult's lap and be buckled in during the tour. Should you wish to bring a car seat with you we ask that you let us know in advance so we can be prepared. Please note, if you do choose to bring a car seat with you, it is your responsibility to install and uninstall the seat at each stop on the tour."
      }
    },
    {
      '@type': 'Question',
      name: 'Is the tour price in Canadian or US dollars?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The tour price should default to your local currency based on your location. You may select a different currency than the default from the dropdown menu if you choose.'
      }
    },
    {
      '@type': 'Question',
      name: 'Is there anything not included in the price of the tour?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Prices listed for the tours are inclusive of all taxes and fees. If you select a tour that does not include meals, we may recommend bringing extra cash to purchase food at stops or bringing snacks with you. Souvenirs and other items you may purchase on your tour are also not included in the price of your tour. Gratuities are optional and always appreciated.'
      }
    },
    {
      '@type': 'Question',
      name: 'When will the guide pick me up for my tour?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We will email or call you 1-3 days prior to your tour to confirm a specific pick up time. If you do not have access to phone or email, please be ready and waiting in the hotel lobby half an hour before your tour start time.'
      }
    }
  ]
};

export default faqPageSchema;
